export const SERVICE = 'PROCUREMENT'
